import apiClient from "@/services/http";

// Default placeholder image for fallback
export const DEFAULT_PLACEHOLDER = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23e0e0e0"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="16" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';

// Directive for image fallback
export const imgFallbackDirective = {
    mounted(el, binding) {
        const fallbackSrc = binding.value || DEFAULT_PLACEHOLDER;
        el._originalFallback = fallbackSrc;

        el._errorHandler = function () {
            if (el.src !== el._originalFallback) {
                el.src = el._originalFallback;
            }
        };

        el.addEventListener('error', el._errorHandler);
    },
    updated(el, binding) {
        const fallbackSrc = binding.value || DEFAULT_PLACEHOLDER;
        el._originalFallback = fallbackSrc;
        
        // If the src changes (Vue patched it), but the browser still errors, the error listener will catch it.
        // If it doesn't error, we want the new src to stay.
        // No extra action needed for update as long as the error listener is attached.
    },
    unmounted(el) {
        if (el._errorHandler) {
            el.removeEventListener('error', el._errorHandler);
        }
    }
};

// Helper function to resolve profile pic URLs correctly
export const getProfilePicUrl = (picPath) => {
  if (!picPath || picPath === 'null') return null;
  if (picPath.startsWith('http')) return picPath;

  const baseUrl = apiClient.defaults.baseURL.endsWith('/')
      ? apiClient.defaults.baseURL.slice(0, -1)
      : apiClient.defaults.baseURL;
  const domain = baseUrl.replace(/\/api\/?$/, '');

  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : null;
  const tokenQuery = token ? `&token=${encodeURIComponent(token)}` : '';

  return `${domain}/api/storage/preview?file=${encodeURIComponent('/' + picPath.replace(/^\//, ''))}${tokenQuery}`;
};

// Helper function to extract first letter safely
export const getFirstLetterAvatar = (name) => {
    if (!name) return '?';
    return name.toString().charAt(0).toUpperCase();
};
